import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";

export const InfoTabsWrapper = styled.div`
    width: 100%;
`;

export const Tab = styled.div<{ isSelected?: boolean }>`
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-radius: 30px;
    gap: 10px;
    cursor: pointer;
    user-select: none;
    background-color: ${({ isSelected }) =>
        isSelected ? colors.grey.dark : colors.grey.tertiary2};

    ${Text.Style} {
        font-size: 14px;
        color: ${({ isSelected }) => (isSelected ? "#fff" : colors.grey.dark)};

        @media (${theme.breakpoints.mobileL}) {
            display: ${({ isSelected }) => (!isSelected ? "none" : "block")};
        }
    }

    svg {
        color: ${({ isSelected }) => (isSelected ? "#fff" : colors.grey.dark)};
    }
`;

export const Tabs = styled.div`
    display: flex;
    margin: 36px 0;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;

    @media (${theme.breakpoints.mobileL}) {
        margin-bottom: 20px;

        ${Tab} {
            padding: 10px;
        }
    }
`;
